import React from 'react';

const Logo = ({ className = "", animate = false }) => (
  <svg 
    className={className} 
    width="60" 
    height="60" 
    viewBox="0 0 60 60" 
    fill="none"
  >
    <path
      d="M10 20 L 50 20"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
      style={animate ? {
        strokeDasharray: 40,
        strokeDashoffset: 40,
        animation: 'drawLine 0.6s cubic-bezier(0.25, 0.1, 0.25, 1) forwards'
      } : {}}
    />
    <path
      d="M10 40 Q 30 20, 50 40"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
      style={animate ? {
        strokeDasharray: 70,
        strokeDashoffset: 70,
        animation: 'drawArc 1s cubic-bezier(0.25, 0.1, 0.25, 1) 0.6s forwards'
      } : {}}
    />
  </svg>
);

export default Logo;